export var EAIAgentType;
(function (EAIAgentType) {
    EAIAgentType["ARB"] = "ARB";
    EAIAgentType["CHATBOT"] = "CHATBOT";
    EAIAgentType["GUARDRAIL"] = "GUARDRAIL";
    EAIAgentType["TOOL"] = "TOOL";
    EAIAgentType["HANDOFF"] = "HANDOFF";
})(EAIAgentType || (EAIAgentType = {}));
